/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsOilDroplet: {
  name: 'oil-droplet';
  data: string;
} = {
  name: 'oil-droplet',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.308.607a.5.5 0 0 0-.616 0C4.009 3.494 2.5 7.229 2.5 10.1c0 2.992 2.472 5.4 5.5 5.4s5.5-2.408 5.5-5.4c0-2.871-1.509-6.606-5.192-9.493ZM3.5 10.1c0-2.464 1.268-5.786 4.5-8.458 3.232 2.672 4.5 5.994 4.5 8.458 0 2.42-2.005 4.4-4.5 4.4s-4.5-1.98-4.5-4.4Zm3-.1a.5.5 0 0 0-1 0A2.5 2.5 0 0 0 8 12.5a.5.5 0 1 0 0-1A1.5 1.5 0 0 1 6.5 10Z" fill="currentColor"/></svg>`,
};
